import { createSlice } from "@reduxjs/toolkit";
import { allReport, blockUnblockedReport, warnToReportedUser } from "../action/reportAction";

const initialState = {
  isLoading: false,
  allreportList: [],
  blockUnblockedReport: {},
};

export const reportSlice = createSlice({
  name: "report",
  initialState: initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-users
    builder.addCase(allReport.pending, (state, action) => {
      state.isLoading = true;;
    });
    builder.addCase(allReport.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? [];
      state.allreportList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(allReport.rejected, (state, action) => {
      state.isLoading = false;
    });


    // UBlocked-Unblocked-report
    builder.addCase(blockUnblockedReport.pending, (state, action) => {
      state.isLoading = true;;
    });
    builder.addCase(blockUnblockedReport.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(blockUnblockedReport.rejected, (state, action) => {
      state.isLoading = false;
    });

    // warnToReportedUser
    builder.addCase(warnToReportedUser.pending, (state, action) => {
      state.isLoading = true;;
    });
    builder.addCase(warnToReportedUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(warnToReportedUser.rejected, (state, action) => {
      state.isLoading = false;
    });

  },
});


export default reportSlice.reducer;

